export default __webpack_public_path__ + "static/media/savings-visual-1.f63afce5.png";